import { isValidNumber } from "@frontiers-vue3/public-pages";
import { useMain } from "~/stores/main";

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) return;
  if (!to.name?.toString().includes("research-topics-rtId-rtSlug")) return;

  const { rtId } = to.params;
  const researchTopicId = Number(rtId);
  const store = useMain();
  const configStore = useEnvironmentConfigStore();
  const terminologyStore = useTerminologyStore();
  const {
    youngMindsJournalId,
    public: { domain }
  } = useRuntimeConfig();

  // TERMINOLOGY: Ensure the terminology is fetched before the research topic, otherwise a race condition can occur
  configStore.fetchValidatedConfig();
  terminologyStore.init();

  // RESEARCH TOPIC
  await store.fetchCurrentResearchTopic(researchTopicId);

  const primaryJournal = store.getPrimaryJournal;

  if (!primaryJournal) {
    return createError({
      statusCode: 500,
      statusMessage: `Primary journal for Research Topic ${researchTopicId} not found`
    });
  }

  if (youngMindsJournalId.toString() === primaryJournal.id.toString()) {
    return navigateTo(
      {
        path: `https://kids.${domain}/collections/${rtId}/${store.currentResearchTopic.slug}`,
        query: to.query
      },
      { redirectCode: 301, external: true }
    );
  }

  store.fetchBreadcrumbs(store.currentResearchTopic);
  await store.fetchContentfulJournal(primaryJournal.slug);
});
